export default ["LocaleService",function dt(LocaleService) {
  var i18nFilter = function (input, args) {   
    return LocaleService.formatDate(input, args);
  };

  return i18nFilter;
}];



// WEBPACK FOOTER //
// ./src/ui/app/filter/dt.js